// custom code HV vi:sit - tooltip behavior
if (!window.ZG_TooltipInitialized) {
  window.ZG_TooltipInitialized = true;

  window.ZG_initTooltips = function () {
    document.querySelectorAll('.tooltip-wrapper').forEach(wrapper => {
      wrapper.addEventListener('click', function () {
        const box = wrapper.querySelector('.tooltip-box');
        if (box) {
          box.classList.toggle('visible');
        }
      });
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('.tooltip-box').forEach(box => {
        if (!box.contains(e.target) && !box.parentElement.contains(e.target)) {
          box.classList.remove('visible');
        }
      });
    });
  };

  // init on page load
  document.addEventListener('DOMContentLoaded', window.ZG_initTooltips);
}
